<!-- Start Landing Page -->
<div class="landing-page">
  <div class="content">
    <div class="container">
      <div class="info">
        <h1>Abre las Puertas de Tu Futuro Laboral en España</h1>
        <p>En VoyJaleas, nos especializamos en transformar la aspiración de trabajar en España en una realidad tangible. Con una profunda comprensión del mercado laboral español y una red amplia de empleadores, te ofrecemos una consultoría personalizada para navegar por el proceso de búsqueda de empleo, visados y adaptación cultural. ¿Estás listo para dar el próximo gran paso en tu carrera profesional? Nosotros estamos aquí para guiarte en cada momento</p>
        <button (click)="openCalendly()">Reserva Tu Consulta Gratuita</button>
      </div>
      <div class="image">
        <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3f4b936a-57a0-41c9-5c46-47f81f8ceb00/public"> 
      </div>
    </div>
  </div>
</div>
<!-- End Landing Page -->